import React from "react";
import styled from "styled-components";
import { Icon } from "../Icon";
import { useEvent } from "../hooks/useEvent";
import { style } from "../style";

type Props = {
  label: string;
  imageUrl?: string;
  onClick(): void;
};

const Container = styled.button`
  all: unset;

  width: 100%;

  display: flex;
  border: 1px solid ${style.colors.grey.primary};
  border-radius: ${style.vars.borderRadius.base};
  cursor: pointer;

  :focus {
    outline: ${style.vars.borderWidth.base} dotted ${style.colors.grey.dark};
    outline-offset: 1px;
  }
`;

const LabelWrapper = styled.div`
  all: unset;

  flex-grow: 1;
  padding: ${style.vars.space[4]} ${style.vars.space[5]};
  font-weight: ${style.vars.fontWeight.bold};
`;

type ImageWrapperProps = {
  $backgroundImageUrl: string;
};

const ImageWrapper = styled.div<ImageWrapperProps>`
  all: unset;

  flex-grow: 1;
  width: 250px;
  background: url(${(props) => props.$backgroundImageUrl});
  background-repeat: no-repeat;
  background-size: 150%;
  background-position: left 0% bottom 100%;
`;

type RefHandler = {
  focus(): void;
};

export const CreatePageAsideCard = React.forwardRef<RefHandler, Props>((props, ref) => {
  const { label, imageUrl = null } = props;
  const buttonRef = React.useRef<HTMLButtonElement>(null);

  const onClick = useEvent<React.MouseEventHandler<HTMLButtonElement>>((ev) => {
    ev.preventDefault();
    props.onClick();
  });

  React.useImperativeHandle(ref, () => {
    return {
      focus() {
        buttonRef.current?.focus();
      },
    };
  });

  return (
    <Container ref={buttonRef} onClick={onClick}>
      <LabelWrapper>
        {label} <Icon icon="slideout" />
      </LabelWrapper>
      {imageUrl && <ImageWrapper $backgroundImageUrl={imageUrl} />}
    </Container>
  );
});

CreatePageAsideCard.displayName = "CreatePageAsideCard";
